
import React from 'react'

import Spinner from '@/Components/SvgImages/Spinner/Spinner'

import './FormSavingStatus.scss'

interface Props {
  saving: boolean
}

const FormSavingStatus = (props: Props) => {

  return (
    <div className={`saving-status ${props.saving ? '' : 'saving-status-hidden'}`}>
      <Spinner
        height={20}
        width={20}
        fill="#000"
        style={{ marginRight: '0.25rem' }}
      /> Saving...
    </div>
  )
}

export default FormSavingStatus
